module.exports = __webpack_public_path__ + "img/gb95-85-12.prt.d2d2961f.jpg";